import React from "react";
import "../../../../../assets/css/customer/publicCustomerCss/EventBlogs/eventblogs.css";

const TravelGuideSkeleton = ({ imgLeft = true }) => {
  return (
    <article
      className={`eb-card ${
        imgLeft ? "eb-card--img-left" : "eb-card--img-right"
      }`}
    >
      <div className="eb-card-img-wrap">
        <div className="eb-skeleton eb-skeleton-image"></div>
      </div>
      <div className="eb-card-detail">
        <div>
          <div className="eb-skeleton eb-skeleton-small"></div>

          <div className="eb-skeleton eb-skeleton-title"></div>

          <div className="eb-skeleton eb-skeleton-line"></div>
          <div className="eb-skeleton eb-skeleton-line"></div>
          <div className="eb-skeleton eb-skeleton-line short"></div>

          <div className="eb-skeleton eb-skeleton-chip"></div>
          <div className="eb-skeleton eb-skeleton-chip"></div>
          <div className="eb-skeleton eb-skeleton-chip"></div>
        </div>

        <div className="eb-like-row">
          <div className="eb-author-chip">
            <div className="eb-skeleton eb-skeleton-avatar"></div>
            <div className="eb-skeleton eb-skeleton-author"></div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default TravelGuideSkeleton;